// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"

import { colors } from "../../utils/theme/colors"
import { fontWeights } from "../../utils/theme/font-weights"
import { mediaQueries } from "../../utils/theme/media-queries"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Container from "../layout/container"
import ContactRedirection from "../contact-redirection"
import heroContent from "../../content/agence-amazon/hero.json"
import Span from "../common/span"
import BackgroundImage from "gatsby-background-image"

const Hero = ({ langKey }) => {
  const data = useStaticQuery(graphql`
    query AgenceHeroQuery {
      Rocket: file(relativePath: { eq: "fusee-seelk-agence.png" }) {
        childImageSharp {
          fixed(width: 660, height: 615, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      RocketMobile: file(relativePath: { eq: "fusee-seelk-agence.png" }) {
        childImageSharp {
          fixed(width: 254, height: 222) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      background: file(relativePath: { eq: "AgenceAmazonHeroBackground.png" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const { title1, title2, paragraph, button } = heroContent[langKey]

  return (
    <BackgroundImage fluid={data.background.childImageSharp.fluid}>
      <Container>
        <div
          sx={{
            display: `flex`,
            paddingTop: [`4rem`, `4rem`, `10rem`, `10rem`],
          }}
        >
          <div
            sx={{
              marginTop: `4.11rem`,
              [mediaQueries.lg]: {
                width: `40%`,
                marginBottom: `-1.5rem`,
              },
            }}
          >
            <div>
              <h1
                sx={{
                  color: colors.white,
                  fontWeight: fontWeights.black,
                  fontSize: `1.6rem`,
                  [mediaQueries.lg]: {
                    fontSize: `3.5rem`,
                  },
                }}
              >
                {title1}&nbsp;
                <Span text={title2} />
              </h1>
            </div>
            <div sx={{ width: [`100%`, `100%`, `90%`, `90%`] }}>
              <p
                sx={{
                  color: colors.white,
                  fontSize: `0.94rem`,
                  [mediaQueries.lg]: {
                    fontWeight: fontWeights.bold,
                    fontSize: `1.125rem`,
                  },
                }}
              >
                {paragraph}
              </p>
            </div>
            <div
              sx={{
                marginBottom: `13rem`,
                width: "fit-content",
                [mediaQueries.lg]: {
                  marginBottom: `0rem`,
                },
              }}
            >
              <ContactRedirection
                href={
                  langKey === "en"
                    ? "https://www.jellyfish.com/en-us/contact-us"
                    : "https://www.jellyfish.com/fr-fr/contact-us"
                }
                buttonContent={button}
              />
            </div>
          </div>

          <div
            sx={{
              width: `60%`,
              position: `absolute`,
              left: `30%`,
              display: `none`,
              [mediaQueries.lg]: {
                display: `flex`,
              },
            }}
          >
            <Img alt="" fixed={data.Rocket.childImageSharp.fixed} />
          </div>

          <div
            sx={{
              position: `absolute`,
              left: `4%`,
              top: `75%`,
              display: `flex`,
              [mediaQueries.lg]: {
                display: `none`,
              },
            }}
          >
            <Img alt="" fixed={data.RocketMobile.childImageSharp.fixed} />
          </div>
        </div>
      </Container>
    </BackgroundImage>
  )
}

export default Hero
